import { Box, Card, Grid, makeStyles } from '@material-ui/core';
// Functions
import { isPremiumOption } from 'src/functions/individualOptionHelpers';
// components
import IndividualPriceDetail from 'src/components/screens/components/IndividualPriceDetail';

const useStyles = makeStyles(() => ({
  cardRoot: {
    position: 'relative',
    minWidth: 275,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    background: (isPremium): string =>
      isPremium
        ? 'linear-gradient(0.16deg, #ffffff 13.23%, #cee8ff 105.34%)'
        : '',
  },
  triangle: {
    position: 'absolute',
    borderTop: '48.45px solid #f3ba27ed',
    borderRight: '55.45px solid transparent',
  },
  star: {
    position: 'absolute',
    top: '5px',
    left: '4px',
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 20,
    paddingBottom: 15,
    paddingLeft: 41,
    paddingRight: 41,
  },
}));

type Props = {
  anualPrice: number;
  moneyType: string | undefined;
  packageOption: number;
};

const OptionPriceSumaryCard = ({
  anualPrice,
  moneyType,
  packageOption,
}: Props): JSX.Element => {
  const premiumOption = isPremiumOption(packageOption);
  const classes = useStyles(premiumOption);

  return (
    <Card
      className={classes.cardRoot}
      elevation={0}
      data-testid="option-price-sumary-card"
    >
      {premiumOption && (
        <>
          <Box className={classes.triangle} />
          <img
            data-testid="premium-star-icon"
            src="svg/premium_start.svg"
            alt="premium star"
            className={classes.star}
          />
        </>
      )}

      <Grid item className={classes.container}>
        <Grid container item spacing={1} direction="column">
          <IndividualPriceDetail
            data-testid="individual-price-detail"
            anualPrice={anualPrice}
            moneyType={moneyType}
            packageOption={packageOption}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default OptionPriceSumaryCard;
